
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"11","height":"17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#B6B6B6","d":"M9.378 1.165C8.297.388 6.938 0 5.304 0 4.061 0 3.011.273 2.16.82.806 1.676.087 3.13 0 5.179h3.136c0-.598.175-1.172.524-1.727.35-.553.943-.83 1.78-.83.852 0 1.44.225 1.759.673.321.45.481.949.481 1.495 0 .476-.239.91-.528 1.306-.158.23-.367.443-.627.636 0 0-1.7 1.086-2.446 1.96-.432.504-.471 1.263-.51 2.35-.002.076.027.237.299.237h2.437c.243 0 .293-.178.296-.259.017-.394.061-.598.134-.826.137-.432.51-.808.928-1.133l.863-.592c.78-.605 1.4-1.101 1.676-1.49.468-.639.798-1.426.798-2.361 0-1.526-.541-2.675-1.622-3.453zM5.254 13.15c-1.08-.033-1.971.712-2.005 1.88-.034 1.165.813 1.937 1.894 1.968 1.127.033 1.995-.687 2.03-1.854.032-1.168-.79-1.96-1.92-1.994z"}})])
          )
        }
      }
    